import React, { useState, useMemo, useEffect, useCallback } from 'react';
import { useHistory, useParams } from 'react-router-dom';

// BIBLIOTECA DATE-FNS
import { ptBR } from 'date-fns/locale';
import { format } from 'date-fns-tz';
import { startOfDay, startOfYear } from 'date-fns';

// ESTILIZAÇÃO
import {
  Backdrop,
  Box,
  Button,
  ButtonGroup,
  CircularProgress,
  Collapse,
  Container,
  Fade,
  Grid,
  List,
  ListItem,
  Modal,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tab,
  Tabs,
  Typography,
} from '@material-ui/core/';
import { useStyles } from './style';

// COMPONENTS
import { IncFilterOpsType } from '../../components/FilterBar';
import MapMarker from '../../components/MapMarker';
import TableRegister from '../../components/TableRegister';

// SERVIÇOS
import { Agent, MissionCar, RecordsResponseType } from '../../@types/records';
import api from '../../services/api';
import { DriverIncidenteDetailsType } from '../../@types/records';
import { toDate } from '../../utils/formatDate';
import Colors from '../../components/Colors';
import { getFilterDates } from '../../actions/managementActions';
import ShowSnackbar, { SetSnackbarType } from '../../components/SnackBar';

interface ResponseManagement {
  uuid: string;
  datetime_begin: string;
  datetime_end: string;
  datetime_map_begin: string;
  datetime_map_end: string;
}
interface Vehicle {
  Categoria: string;
  Cor: string;
  'Código Veículo': string;
  Espécie: string;
  Manobra: string;
  Danificado: string;
  'Formulario de Dano': damageFormData;
  'Tipo Veículo': string;
  Aluguel: string;
  Marca: string;
  'Número do Ônibus': string;
  Placa: string;
  'Ano Fabricação': string;
  Legalizado: string;
  _localId: string;
  'Linha do Ônibus': string;
  'Outra manobra': string;
  'Via de Acesso': string;
}
interface Street {
  'Condição da Calçada': string;
  Nome: string;
  'Sinalização Vertical': string;
  'Condição da Pista': string;
  'Sinalização Horizontal': string;
  'Faixa para Sentido': string;
  'Alinhamento Vertical': string;
  'Obra de Arte': string;
  'Tipo do Pavimento': string;
  _localId: string;
  'Alinhamento Horizontal': string;
  'Separação Central': string;
  'Tipo da Pista': string;
  'Obras na Pista': string;
}
interface damageItem {
  label: string;
  answer: string;
}
interface damageFormData {
  DamageType: string;
  structure: string;
  DamageFormDetails: damageItem[];
}
interface Victim {
  'Usava Cinto ou Capacete': string;
  'Data de Alta': string;
  Nome: string;
  'Data de Internação': string;
  'Categoria do Condutor': string;
  'Tipo de Morte': string;
  'Início de Reabilitação': string;
  'Grau de Instrução': string;
  Encaminhamento: string;
  'Tipo de Pessoa': string;
  'Orgão Emissor': string;
  Endereço: string;
  Sexo: string;
  Idade: string;
  'Situação do Condutor': string;
  'Primeira CNH': string;
  'Exame de alcoolemia': string;
  Observações: string;
  'Motivo da Viagem': string;
  Dosagem: string;
  'Situação ou Vínculo': string;
  'Código Veículo': string;
  'Possui Deficiência': string;
  'Nome do Pai': string;
  'Posição do Passageiro': string;
  Profissão: string;
  'Data de Nascimento': string;
  'Número Documento': string;
  'Número do cartão de saúde cidadão': string;
  'Data da Óbito': string;
  'Proprietário do Veículo': string;
  'Estado Civil': string;
  'Número da CNH': string;
  'Tipo Documento': string;
  'Procedimentos realizados': string;
  'Removido por': string;
  Lesões: string[];
  'Evolução de Caso': string;
  'Fim da Reabilitação': string;
  'Gravidade da Lesão': string;
  'Custo Geral': string;
  _localId: string;
  Etnia: string;
  'Nome da Mãe': string;
  'Validade da CNH': string;
}
interface IncidentDetails {
  'Superfície da Pista': string;
  Local: string;
  Natureza: string;
  Jurisdição: string;
  Tempo: string;
  'Hora informada': string;
  Severidade: string;
  'Endereço 1': string;
  'Controle de Tráfego': string;
  Interseção: string;
  Iluminação: string;
  'Endereço 2': string;
}
interface Register {
  uuid: '';
  data: {
    driverVeiculo: Vehicle[];
    driverVia: Street[];
    driverVitima: Victim[];
    driverIncidenteDetails: DriverIncidenteDetailsType;
    driverAgentsAndVehicles: {
      agents: Agent[];
      missionCars: MissionCar[];
    };
  };
  geom: {
    coordinates: number[];
  };
  modified_by: string;
  created: string;
  modified: string;
  occurred_from: string;
  location_text: string;
}

interface IncidentImages {
  path: string;
  uuid: string;
  description: string;
}

const RegisterDuplicidades: React.FC = () => {
  const initialRecordsResponse: RecordsResponseType = {
    count: 0,
    next: '',
    previous: '',
    results: [],
  };
  const initialFilterOps: IncFilterOpsType = {
    endDate: '',
    startDate: '',
    veiculos: [],
    gravidades: [],
    location: [],
    tipoAcidentes: [],
    bairros: '',
    vias: '',
    regionais: '',
    drawPolygon: {},
  };
  const loadFilterOps = (): IncFilterOpsType => {
    let filterOpsObj: IncFilterOpsType = initialFilterOps;
    const loadedFilterOps = localStorage.getItem('incFilterOps');

    // Carrega a filtragem do Local Storage e armazena no filterOps
    if (loadedFilterOps) {
      filterOpsObj = JSON.parse(loadedFilterOps);
    }

    return filterOpsObj;
  };

  const styles = useStyles();
  const { pathId, pathIdB } = useParams<{ pathId: string; pathIdB: string }>();

  const [admin, setAdmin] = useState<boolean>(false);
  const [typist, setTypist] = useState<boolean>(false);
  const [tecEng, setTecEng] = useState<boolean>(false);
  const [geofi, setGeofi] = useState<boolean>(false);
  const [publicGroup, setPublicGroup] = useState<boolean>(false);
  const [imagens, setImagens] = useState<IncidentImages[]>([]);

  const [loading, setLoading] = useState<boolean>(true);
  const [loadingDate, setloadingDate] = useState<boolean>(true);

  const [active, setActive] = useState<number>(0);
  const [variant, setVariant] = useState<'text' | 'outlined' | 'contained' | undefined>(
    'text',
  );
  const [vehicles, setVehicles] = useState<Vehicle[]>([]);
  const [open, setOpen] = React.useState(false);
  const [street, setStreet] = useState<Street[]>([]);
  const [victim, setVictim] = useState<Victim[]>([]);
  const [damageFormColapseControl, setDamageFormColapseControl] = useState<boolean>(
    false,
  );

  const [register, setRegister] = useState<Register>({
    uuid: '',
    data: {
      driverVeiculo: vehicles,
      driverVia: street,
      driverVitima: victim,
      driverIncidenteDetails: {
        'Superfície da Pista': '',
        Local: '',
        Natureza: '',
        Jurisdição: '',
        Tempo: '',
        'Hora informada': '',
        Severidade: '',
        'Endereço 1': '',
        'Controle de Tráfego': '',
        Interseção: '',
        Iluminação: '',
        'Endereço 2': '',
        'Código do Acidente': '',
        'Elementos Atingidas': '',
        'Ocorrido ao Longo da Via/Cruzamento': '',
        'Primeira Fonte de Informação': '',
        'Tipo de Cruzamento': '',
      },
      driverAgentsAndVehicles: {
        agents: [],
        missionCars: [],
      },
    },
    geom: {
      coordinates: [0, 0],
    },
    modified_by: '',
    created: '',
    modified: '',
    occurred_from: '',
    location_text: '',
  });
  const [startDateMap, setStartDateMap] = useState<string>('2014-01-01T00:00:00Z');
  const [endDateMap, setEndDateMap] = useState<string>('2020-06-30T23:59:59.999000Z');

  const [records, setRecords] = useState<RecordsResponseType>(initialRecordsResponse);
  const [snackbar, setSnackbar] = useState<SetSnackbarType>({ open: false, message: '', });

  const [rowsPerPage, setRowsPerPage] = useState<number>(25);
  const [dateMin, setDateMin] = useState<string>(
    `${process.env.REACT_APP_MAP_START_DEFAULT_DATE}`,
  );
  const [dateMax, setDateMax] = useState<string>(
    `${process.env.REACT_APP_MAP_END_DEFAULT_DATE}`,
  );
  // Armazenando todos os Jsonb carregados na variavel jsonb
  const [pageOffset, setPageOffset] = useState<number>(0);
  const [boundaryPolygon, setBoundaryPolygon] = useState<{}>({
    polygon_id: loadFilterOps().bairros,
  });
  const filterOps: IncFilterOpsType = loadFilterOps();

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const authHeader = useMemo(() => {
    return { Authorization: `Token ${localStorage.getItem('auth')}` };
  }, []);

  const arrayImagens = useCallback(async () => {
    const { data: file } = await api.get<IncidentImages[]>(
      '/api/incident_records/get_images/',
      {
        headers: authHeader,
        params: {
          recordID: pathId,
        },
      },
    );
    setImagens(file);
  }, [authHeader, pathId]);
  const history = useHistory();

  const fetchData = useCallback(async () => {
    setLoading(true);
    const { data } = await api.get<RecordsResponseType>(
      `/api/incident_records/duplicidades/${pathId}/`,

      {
        headers: { Authorization: `Token ${localStorage.getItem('auth')}` },
        // params: {
        //   limit: rowsPerPage,
        //   occurred_min: format(
        //     startOfDay(new Date(filterOps.startDate || dateMin)),
        //     "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'",
        //   ),
        //   occurred_max: filterOps.endDate || dateMax,
        //   offset: pageOffset,
        // },
      },
    );

    setRecords(data);
    setLoading(false);
  }, [
    rowsPerPage,
    dateMin,
    dateMax,
    pageOffset,
    boundaryPolygon,
    filterOps.endDate,
    filterOps.startDate,
  ]);

  useEffect(() => {
    async function loadRegister(id: string) {
      setLoading(true);
      const groups = localStorage.getItem('groups')?.split(' ');
      if (groups) {
        groups.forEach((gr: string) => {
          if (gr === 'public') {
            setPublicGroup(true);
          } else if (gr === 'digitador') {
            setTypist(true);
          } else if (gr === 'tec_engenharia') {
            setTecEng(true);
          } else if (gr === 'geofi') {
            setGeofi(true);
          } else if (gr === 'admin') {
            setAdmin(true);
          }
        });
      }
      const registers = await api.get(`/api/incident_records/${id}/`, {
        headers: authHeader,
        params: {
          details_only:
            (geofi || publicGroup || tecEng) && !(admin || typist) ? 'True' : 'False',
        },
      });

      setRegister(registers.data);
    }
    loadRegister(pathId);
    // arrayImagens();
    fetchData();
    setActive(6);
    if (register.created !== '') {
      setLoading(false);
    }
  }, [
    pathId,
    authHeader,
    admin,
    register.created,
    geofi,
    publicGroup,
    tecEng,
    typist,
    // arrayImagens,
  ]);

  const fetchManagementDate = useCallback(async () => {
    setloadingDate(true);
    try {
      const dates = await getFilterDates(filterOps.startDate, filterOps.endDate);
      setDateMin(dates.dateMin);
      setDateMax(dates.dateMax);
      setStartDateMap(dates.startDateMap);
      setEndDateMap(dates.endDateMap);
    } catch (error) {
      console.log(error);
    } finally {
      setloadingDate(false);
    }

  }, [filterOps.endDate, filterOps.startDate]);

  // Efetua a requisição para coletar os dados com a filtragem passada pelo FilterBar

  return (
    <>
      {loading ? (
        <div className={styles.loadingContainer}>
          <CircularProgress className={styles.loadingSpinner} size={60} thickness={5} />
        </div>
      ) : (
        <Container className={styles.container}>
          <Box className={styles.box}>
            <Button
              // variant={variant}
              className={`${styles.buttons} ${active === 0 ? styles.buttonActive : ''}`}
              onClick={() => {
                setActive(0);
              }}
            >
              Detalhes do Incidente
            </Button>

            <Button
              // variant={variant}
              className={`${styles.buttons} ${active === 6 ? styles.buttonActive : ''}`}
              onClick={() => {
                setActive(6);
              }}
            >
              Duplicidades
            </Button>
          </Box>

          {active === 0 && (
            <>
              <Container className={styles.root}>
                <TableRegister
                  title={['ocorrido', 'criado']}
                  data={[
                    {
                      details: [
                        `${toDate(register.occurred_from)}`,
                        `${toDate(register.created)}`,
                      ],
                    },
                  ]}
                />

                <TableRegister
                  title={['endereço 1', 'endereço 2']}
                  data={[
                    {
                      details: [
                        `${register.data.driverIncidenteDetails['Endereço 1']}`,
                        `${register.data.driverIncidenteDetails['Endereço 2']}`,
                      ],
                    },
                  ]}
                />
                <TableRegister
                  title={['bairro', 'numero/referencia']}
                  data={[
                    {
                      details: [
                        `${register.data.driverIncidenteDetails.Bairro}`,
                        `${register.data.driverIncidenteDetails['Numero Referencia']}`,
                      ],
                    },
                  ]}
                />
                <Container className={styles.containerMap}>
                  <MapMarker
                    point={[register.geom?.coordinates[1], register.geom?.coordinates[0]]}
                    notDragabble
                  />
                </Container>
                <TableRegister
                  title={['latitude', 'longitude']}
                  data={[
                    {
                      details: [
                        `${register.geom?.coordinates[1]}`,
                        `${register.geom?.coordinates[0]}`,
                      ],
                    },
                  ]}
                />
                <TableRegister
                  title={['iluminação', 'severidade']}
                  data={[
                    {
                      details: [
                        `${register.data.driverIncidenteDetails.Iluminação}`,
                        `${register.data.driverIncidenteDetails.Severidade}`,
                      ],
                    },
                  ]}
                />
                <TableRegister
                  title={['natureza', 'jurisdição']}
                  data={[
                    {
                      details: [
                        `${register.data.driverIncidenteDetails.Natureza}`,
                        `${register.data.driverIncidenteDetails.Jurisdição}`,
                      ],
                    },
                  ]}
                />

                <TableRegister
                  title={['tempo', 'uso do solo']}
                  data={[
                    {
                      details: [
                        `${register.data.driverIncidenteDetails.Tempo}`,
                        `${register.data.driverIncidenteDetails.Local}`,
                      ],
                    },
                  ]}
                />
                <TableRegister
                  title={['superfície da pista', 'controle de tráfego']}
                  data={[
                    {
                      details: [
                        `${register.data.driverIncidenteDetails['Superfície da Pista']}`,
                        `${register.data.driverIncidenteDetails['Controle de Tráfego']}`,
                      ],
                    },
                  ]}
                />
              </Container>

              <Container className={styles.small}>
                <TableRegister
                  title={['ocorrido']}
                  data={[
                    {
                      details: [`${toDate(register?.occurred_from)}`],
                    },
                  ]}
                />
                <TableRegister
                  title={['criado']}
                  data={[
                    {
                      details: [`${toDate(register?.created)}`],
                    },
                  ]}
                />

                <TableRegister
                  title={['endereço 1']}
                  data={[
                    {
                      details: [`${register.data.driverIncidenteDetails['Endereço 1']}`],
                    },
                  ]}
                />
                <TableRegister
                  title={['endereço 2']}
                  data={[
                    {
                      details: [`${register.data.driverIncidenteDetails['Endereço 2']}`],
                    },
                  ]}
                />
                <Container className={styles.containerMap}>
                  <MapMarker
                    point={[register.geom.coordinates[1], register.geom.coordinates[0]]}
                    notDragabble
                  />
                </Container>
                <TableRegister
                  title={['latitude']}
                  data={[
                    {
                      details: [`${register.geom.coordinates?.[1]}`],
                    },
                  ]}
                />
                <TableRegister
                  title={['longitude']}
                  data={[
                    {
                      details: [`${register.geom.coordinates?.[0]}`],
                    },
                  ]}
                />
                <TableRegister
                  title={['iluminação']}
                  data={[
                    {
                      details: [`${register.data.driverIncidenteDetails.Iluminação}`],
                    },
                  ]}
                />
                <TableRegister
                  title={['severidade']}
                  data={[
                    {
                      details: [`${register.data.driverIncidenteDetails.Severidade}`],
                    },
                  ]}
                />
                <TableRegister
                  title={['natureza']}
                  data={[
                    {
                      details: [`${register.data.driverIncidenteDetails.Natureza}`],
                    },
                  ]}
                />
                <TableRegister
                  title={['jurisdição']}
                  data={[
                    {
                      details: [`${register.data.driverIncidenteDetails.Jurisdição}`],
                    },
                  ]}
                />
                <TableRegister
                  title={['tempo']}
                  data={[
                    {
                      details: [`${register.data.driverIncidenteDetails.Tempo}`],
                    },
                  ]}
                />
                <TableRegister
                  title={['uso do solo']}
                  data={[
                    {
                      details: [`${register.data.driverIncidenteDetails.Local}`],
                    },
                  ]}
                />
                <TableRegister
                  title={['superfície da pista']}
                  data={[
                    {
                      details: [
                        `${register.data.driverIncidenteDetails['Superfície da Pista']}`,
                      ],
                    },
                  ]}
                />
                <TableRegister
                  title={['controle de tráfego']}
                  data={[
                    {
                      details: [
                        `${register.data.driverIncidenteDetails['Controle de Tráfego']}`,
                      ],
                    },
                  ]}
                />
              </Container>
            </>
          )}

          {active === 6 && (
            <>
              <TableContainer className={styles.tableContainer}>
                <Table className={styles.table}>
                  <TableHead className={styles.tableHead}>
                    <TableRow>
                      <TableCell
                        className={styles.responsive}
                        style={{ color: '#404040' }}
                      >
                        Data e Hora
                      </TableCell>

                      <TableCell style={{ color: '#404040' }}>Endereço 1</TableCell>
                      <TableCell style={{ color: '#404040' }}>Endereço 2</TableCell>

                      <TableCell />
                    </TableRow>
                  </TableHead>
                  {/* <TableRegister title={['Data e Hora', 'Endereço', '']} /> */}

                  <TableBody>
                    {records.results.map((value) => (
                      <TableRow key={value.uuid} hover>
                        <TableCell className={styles.responsive}>
                          {`${format(
                            new Date(value.occurred_from),
                            'dd MMMM, yyyy, HH:mm',
                            {
                              locale: ptBR,
                            },
                          )}`}
                        </TableCell>
                        <TableCell>
                          {value.data.driverIncidenteDetails['Endereço 1']}
                        </TableCell>
                        <TableCell>
                          {value.data.driverIncidenteDetails['Endereço 2']}
                        </TableCell>
                        <TableCell>
                          <div className={styles.buttonsCol}>
                            <a
                              href={`/analise/duplicidade/${pathId}&${value.uuid}`}
                              rel="noopener noreferrer"
                              style={{ textDecoration: 'none', color: 'black' }}
                            >
                              <Button
                                size="small"
                                variant="outlined"
                                className={styles.button}
                              >
                                Verificar duplicidade
                              </Button>
                            </a>
                          </div>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </>
          )}
        </Container>
      )}
    </>
  );
};

export default RegisterDuplicidades;

